import React from "react";
import "./AboutUs.css";

const teamMembers = [
  {
    name: "Elnaz",
    role: "Frontend Developer",
    description:
      "PoliTo student crafting immersive digital experiences. Passionate about pixel-perfect UIs, motion design, and turning complex ideas into elegant interfaces.",
    linkedin: "https://linkedin.com/in/elnazjavani",
    initials: "EL",
    accentVar: "--accent-violet",
  },
  {
    name: "Alessio",
    role: "Backend Developer",
    description:
      "PoliTo student engineering the unseen architecture. Focused on scalable systems, clean APIs, and building the robust foundations that power great products.",
    linkedin: "https://linkedin.com/in/alessio-nicotra-85324a399",
    initials: "AL",
    accentVar: "--accent-teal",
  },
];

export default function AboutUs() {
  return (
    <section className="about-section">
      <div className="about-bg-grid" aria-hidden="true" />
      <div className="about-bg-glow about-bg-glow--left" aria-hidden="true" />
      <div className="about-bg-glow about-bg-glow--right" aria-hidden="true" />

      <div className="about-header">
        <span className="about-label">The Team</span>
        <h2 className="about-title">
          Meet <span className="about-title-brand">DevLab</span>
        </h2>
        <p className="about-subtitle">
          Two students. One lab. Infinite builds.
        </p>
      </div>

      <div className="cards-row">
        {teamMembers.map((member) => (
          <div
            className="member-card"
            key={member.name}
            style={{ "--card-accent": `var(${member.accentVar})` }}
          >
            <div className="card-noise" aria-hidden="true" />
            <div className="card-border-glow" aria-hidden="true" />

            <div className="card-inner">
              <div className="card-avatar-wrap">
                <div className="card-avatar">
                  <span className="card-initials">{member.initials}</span>
                  <div className="avatar-ring" aria-hidden="true" />
                  <div className="avatar-pulse" aria-hidden="true" />
                </div>
              </div>

              <div className="card-identity">
                <h3 className="card-name">{member.name}</h3>
                <p className="card-role">{member.role}</p>
              </div>

              <div className="card-reveal">
                <div className="card-divider" aria-hidden="true" />
                <p className="card-description">{member.description}</p>
                <a
                  href={member.linkedin}
                  className="card-linkedin"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={`${member.name} on LinkedIn`}
                >
                  <svg
                    className="linkedin-icon"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    aria-hidden="true"
                  >
                    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                  </svg>
                  <span>Connect on LinkedIn</span>
                  <svg
                    className="arrow-icon"
                    viewBox="0 0 16 16"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    aria-hidden="true"
                  >
                    <path d="M3 8h10M9 4l4 4-4 4" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </a>
              </div>
            </div>

            <div className="card-corner card-corner--tl" aria-hidden="true" />
            <div className="card-corner card-corner--br" aria-hidden="true" />
          </div>
        ))}
      </div>

      
    </section>
  );
}